/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Downtime } from '../../models/downtime';

export interface GetDowntime$Params {
  downtimeId: number;
}

export function getDowntime(http: HttpClient, rootUrl: string, params: GetDowntime$Params, context?: HttpContext): Observable<StrictHttpResponse<Downtime>> {
  const rb = new RequestBuilder(rootUrl, getDowntime.PATH, 'get');
  if (params) {
    rb.path('downtimeId', params.downtimeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Downtime>;
    })
  );
}

getDowntime.PATH = '/api/v1/Downtimes/{downtimeId}';
